module.exports = __webpack_public_path__ + "static/media/default-lib-pattern.e687fa09.jpg";